// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"mail_scrollableContent_2JQNF","message":"mail_message_2Jzst"};